export const SET_HTTP_ERROR_SETTING = "[Http Errors] Set A New HTTP Error";
